const makeUrl = (pathname: string): string => {
  if (import.meta.env.REACT_APP_BACKEND_URL === "/") {
    // we're in a CORS-less mode, paths to the frontend will work
    return fullyQualifiedUrl(pathname);
  }
  if (import.meta.env.REACT_APP_BACKEND_URL) {
    const url = new URL(import.meta.env.REACT_APP_BACKEND_URL);
    url.pathname = pathname;
    return url.href;
  }
  throw new Error("please define REACT_APP_BACKEND_URL");
};

export type ImageResourceType = "Profile" | "room" | "event" | "organization" | "Bubbles";
export const makeImageResourceAvatarUrl = (resourceType: ImageResourceType, resourceId: string): string =>
  makeUrl(`/api/v1/${resourceType}/${resourceId}/picture`);
export const makeProfileAvatarUrl = (userId: string): string => makeImageResourceAvatarUrl("Profile", userId);
export const makeRoomAvatarUrl = (roomId: string): string => makeImageResourceAvatarUrl("room", roomId);
export const makeEventAvatarUrl = (eventId: string): string => makeImageResourceAvatarUrl("event", eventId);
export const makeOrganizationAvatarUrl = (organizationId: string): string =>
  makeImageResourceAvatarUrl("organization", organizationId);
export const makeBubbleAvatarUrl = (bubbleId: string): string => makeImageResourceAvatarUrl("Bubbles", bubbleId);

/** @deprecated use fullyQualifiedUrl and `services/router/Route` */
export const makeRoomUrl = (roomId: string): string => {
  if (window.location.href) {
    const url = new URL(window.location.href);
    url.pathname = `/rooms/${roomId}`;
    return url.href;
  }
  throw new Error("please define REACT_APP_BACKEND_URL");
};

/** builds a full url to the given path, intended to be used with
 * `services/router/Route` */
export const fullyQualifiedUrl = (pathname: string): string => {
  const url = new URL(window.location.href);
  url.pathname = pathname;
  return url.href;
};

/** sleeps for the given amount of time */
export const sleep = (delayMillis: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, delayMillis);
  });

/** retry an async operation with delays */
export const withRetries = async (callback: () => Promise<void>, retries = 5, delayMillis = 1000): Promise<boolean> => {
  for (let i = 0; i < retries; i++) {
    try {
      await callback();
      return true;
    } catch (err) {
      console.warn("unexpected error", err);
      await sleep(delayMillis); // wait a little before trying again
    }
  }
  return false;
};

/** is the given token expired? */
export const isTokenExpired = (token: string): boolean => {
  try {
    // decode JWT, find the expiration date
    const exp = new Date(JSON.parse(atob(token.split(".")[1])).exp * 1000);
    return new Date() > exp;
  } catch {
    return true;
  }
};

export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
  } catch {
    return false;
  }

  return true;
};
